var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Arrow-Right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 2874 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.85005 3.30806C7.09413 3.06398 7.48986 3.06398 7.73393 3.30806L13.9839 9.55806C14.228 9.80214 14.228 10.1979 13.9839 10.4419L7.73393 16.6919C7.48986 16.936 7.09413 16.936 6.85005 16.6919C6.60597 16.4479 6.60597 16.0521 6.85005 15.8081L12.6581 10L6.85005 4.19194C6.60597 3.94786 6.60597 3.55214 6.85005 3.30806Z",
    fill: "#BEBEBE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight2);
export default __webpack_public_path__ + "static/media/arrow-right2.8f8fe1287ce50bd3954535689c96786c.svg";
export { ForwardRef as ReactComponent };